<template>
  <div style="overflow: hidden">
    <div class="wrapper">
      <div class="add_course_head">
        <div></div>
        <div>作业/习题微视频</div>
        <div class="add_course_head_save"></div>
      </div>
      <div class="content">
        <div class="course_list">
          <el-table :data="videoList" border style="width: 100%">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="name" label="视频名称"> </el-table-column>
            <el-table-column prop="createtime" label="创建日期" width="180">
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <!-- <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  >下载</el-button
                > -->
                <el-button
                  size="mini"
                  @click="openVideo(scope.row)"
                  >预览</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: right; margin-top: 10px" v-if="total">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="params.page"
            :page-size="20"
            background
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="预览"
      :visible.sync="dialogVisible_previewData"
      :before-close="handleClose"
      width="70%"
      custom-class="sign_course_edit_rich_guide_dia_prew"
    >
      <iframe
        :src="video_url"
        frameborder="0"
        style="width: 100%; height: 60vh"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
import preventReClick from "../../config/preventReclick"; //防多次点击，重复提交
export default {
  components: { preventReClick },
  data() {
    return {
      dialogVisible_previewData: false,
      video_url: "",
      params: {
        myself: 1,
        current_page: 1,
        page_size: 20,
      },
      videoList: [],
      total: 0,
    };
  },
  filters: {
    dataFormat(input, pattern = "") {
      // 在参数列表中 通过 pattern="" 来指定形参默认值，防止报错
      var dt = new Date(input * 1000);
      // 获取年月日
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, "0");
      var d = dt.getDate().toString().padStart(2, "0");
      // 如果 传递进来的字符串类型，转为小写之后，等于 yyyy-mm-dd，那么就返回 年-月-日
      // 否则，就返回  年-月-日 时：分：秒
      if (pattern.toLowerCase() === "yyyy-mm-dd") {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, "0");
        var mm = dt.getMinutes().toString().padStart(2, "0");
        var ss = dt.getSeconds().toString().padStart(2, "0");
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
      }
    },
  },
  //监听路由变化 控制首页背景图
  watch: {},
  created() {},

  beforeMount() {},
  mounted() {
    this.getVideoList();
  },
  methods: {
    handleClose(){
      this.video_url = ''
      this.dialogVisible_previewData = false;
    },
    getVideoList() {
      this.axios
        .post("/school/tiku_video/tikuVideoList", this.params)
        .then((res) => {
          if (res.data.code == 1) {
            this.videoList = res.data.data.data;

            this.total = res.data.data.count;
          }
        });
    },
    handleCurrentChange(val) {
      this.params.current_page = val;
      this.getVideoList();
    },
    openVideo(item) {
      this.video_url = item.url;
      this.dialogVisible_previewData = true;
    },
  },
};
</script>
<style >
</style>
<style scoped>
.wrapper {
  margin: 14px auto;
  /* background: #ffffff; */
  height: calc(100vh - 152px);
  overflow: auto;
  border-radius: 12px;
  overflow: hidden;
  /* padding:20px 0; */
  width: 75vw;
}
.add_course_head {
  padding: 0 20px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 60px;
  /* padding-top: 17px; */
  margin-bottom: 14px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(204, 204, 204, 0.5);
  border-radius: 8px;
}
.add_course_head img {
  display: block;
  width: 24px;
  height: 20px;
  margin: 20px 0;
  cursor: pointer;
}

.content {
  height: calc(100vh - 240px);
  background: #ffffff;
  padding-top: 10px;
}
.content_box_head {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: space-between;
  margin: 0px 16px 17px 18px;
  height: 40px;
}
.content_search {
  height: 40px;
}
.content_search >>> .el-input-group__append {
  border-radius: 0 20px 20px 0;
}
.content_search >>> .el-input__inner {
  border-radius: 20px 0 0 20px !important;
  background: #f8f8f8;
  height: 40px !important;
  font-size: 16px !important;
}
.content_search >>> .el-input {
  height: 40px;
}
.area_popper_course .popper__arrow::after {
  border-bottom-color: #ff9b36 !important;
}
.area_popper_course {
  border-color: #ff9b36;
  width: 150px;
  /* height: 400px; */
  padding-right: 0;
}
.course_creat_sort_btn {
  height: 36px;
  background: #f8f8f8;
  border-radius: 10px;
  padding: 0 15px;
  line-height: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.course_creat_sort_options > div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  height: 35px;
  line-height: 35px;
  width: 138px;
  cursor: pointer;
}
.course_creat_sort_options_disable {
  color: #999999 !important;
  cursor: auto !important;
}
.course_creat_sort_options_disable:nth-of-type(2n) {
  border-top: 1px solid #999999;
}
.color_active {
  color: #ff9b36 !important;
}
.creat_course {
  /* width: 78px; */
  height: 36px;
  background: #ff9b36;
  border-radius: 10px;
  line-height: 36px;
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  margin-left: 16px;
  padding: 0 10px;
}
.course_list {
  height: calc(100% - 60px);
  margin: 0 16px 0 18px;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.course_card {
  height: 300px;
  width: 260px;
  border: 4px solid #69b4ff;
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  border-radius: 6px 20px 20px 6px;
  box-sizing: border-box;
  margin-bottom: 20px;
  margin-right: 20px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.teaching_card {
  height: 200px !important;
}
.course_card_title {
  height: 30px;
  line-height: 20px;
  display: flex;
  align-items: center;
  /* margin-bottom: 20px; */
}
.course_card_title_icon img {
  display: block;
}
.course_card_title_name {
  width: 130px;
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  margin-left: 5px;
  margin-right: 10px;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.course_card_content_item {
  font-size: 16px;
  font-family: Microsoft YaHei;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.course_card_operation {
  display: flex;
  justify-content: space-between;
}
.course_card_operation_item {
  cursor: pointer;
}
.course_card_operation_item img {
  display: block;
  width: 26px;
  height: 26px;
}
.add_material_content_head {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  margin: 10px 0;
}
.add_material_content_des {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin: 10px 0;
}
.uploader-btn {
  height: 36px !important;
  background: #ff9b36 !important;
  border-radius: 10px !important;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  border: 0;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.add_course_info_content_box_content_item {
  margin: 0 21px 21px 0;
  cursor: pointer;
}
.add_course_info_content_box_content {
  display: flex;
  flex-wrap: wrap;
  margin: 50px 0 30px 0;
}
.add_course_info_content_box_content_item_img {
  width: 120px;
  height: 100px;
  background: #ffffff;
  border: 1px solid #ff9b36;
  border-radius: 12px;
  position: relative;
}
.add_course_info_content_box_content_item_del {
  width: 13px;
  height: 13px;
  cursor: pointer;
  position: absolute;
  right: -6px;
  top: -6px;
}
.add_course_info_content_box_content_item_del img {
  display: block;
  width: 13px;
  height: 13px;
}
</style>
